﻿import { Component} from '@angular/core';
import { Tabla} from '../../_components/tabla';

@Component({ templateUrl: 'producto.component.html' })
export class RootProductoComponent {

    data: any;

    tabla: Tabla = {
        titulo: 'Productos',
        hideHeader: false,
        hideFilter: false,
        externalData: false,
        endPoint: '/rest-api/root/producto',
        editable: true,
        nuevo: true,
        columnas: [
            {
                name: 'id',
                prop: 'id',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 75,
                hidden: true
            },
            {
                name: 'Nombre',
                prop: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 75
            },
/*            {
                name: 'Descripci&oacute;n',
                prop: 'descripcion',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 150
            },*/
            {
                name: 'Imagen',
                prop: 'imagen',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 150
            },
            {
                name: 'Precio',
                prop: 'precio',
                editable: true,
                resizeable: true,
                sortable: true,
                icon: true,
                width: 100
            }
        ]
    };

    constructor() {}

}
